import { openLastActiveFileSaga } from 'features/content-library/sagas/openLastActiveFileSaga';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import {
  selectContentLibraryActiveFiles,
  selectContentLibraryOpenedFile,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { signalingContentLibraryFileClosed } from 'features/content-library/actions';
import { GridPanelName } from 'features/layout/features/content/types';
import { gridPanelVoided, selectGridPanel } from 'features/layout/features/content/contentSlice';
import { clearLockedContentSaga } from 'features/layout/features/content/sagas/clearLockedContentSaga';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { call, put, select } from 'redux-saga/effects';

export function* onContentLibraryFileClosedSaga(
  action: ReturnType<typeof signalingContentLibraryFileClosed>
) {
  yield call(clearLockedContentSaga, { type: 'file', id: action.payload.id });

  const openedFile: ContentLibraryOpenedFile | null = yield select(selectContentLibraryOpenedFile);
  const shouldOpenAnother = openedFile === null || openedFile.id === action.payload.id;

  const currentOpenedPanel: GridPanelName = yield select(selectGridPanel);
  const files: ContentLibraryOpenedFile[] = yield select(selectContentLibraryActiveFiles);
  const filteredFiles = files.filter((item) => item.id !== action.payload.id);

  if (currentOpenedPanel === 'contentLibrary' && filteredFiles.length > 0) {
    if (shouldOpenAnother) {
      yield call(openLastActiveFileSaga, action.payload.id);
    }

    return;
  }

  if (filteredFiles.length === 0) {
    const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

    if (
      (!previewedFile || previewedFile.type === 'whiteboard') &&
      contentBoard.id &&
      contentBoard.type === 'file'
    ) {
      yield call(contentBoard.reset);
    }

    yield put(gridPanelVoided('contentLibrary'));
  }
}
